import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { renderRecordColor } from 'utils';
import { useRoles } from 'hooks/useRoles';

interface UsersCountProps {
    makerRecords: number;
    checkerRecords: number;
    approverRecords: number;
    title?: string;
}

const UsersCount = (
    { makerRecords, checkerRecords, approverRecords, title = "User Counts" }: UsersCountProps
) => {
    const { isPSPAdminRole, isBUAdminPSP, isBUAdmin } = useRoles();

    return (
        <Flex gap="20px">
            <Text>
                {title}:
            </Text>
            {(isBUAdmin || isPSPAdminRole) && (
                <>
                    <Text>
                        {isPSPAdminRole ? "PSP" : "Business"} Maker
                        <Text as="span" color={renderRecordColor(makerRecords)} ml="5px">
                            {makerRecords}
                        </Text>
                    </Text>

                    <Text>
                        {isPSPAdminRole ? "PSP" : "Business"} Checker
                        <Text as="span" color={renderRecordColor(checkerRecords)} ml="5px">
                            {checkerRecords}
                        </Text>
                    </Text>
                </>
            )}

            {isBUAdminPSP && (
                <Text>
                    Business Approver
                    <Text as="span" color={renderRecordColor(approverRecords)} ml="5px">
                        {approverRecords}
                    </Text>
                </Text>
            )}

        </Flex>
    );
};

export default UsersCount;